import { DetailsItem as Item } from '@calendly/booking-kit'
import { UserMultipleIcon } from '@calendly/ui/components/icons'

export default ({ items, bookingAppRedesign = false }) => items.length > 1 && (
  <Item>
    <UserMultipleIcon size={bookingAppRedesign ? 'standard' : 'large'} spacingRight={8} />
    {items.join(', ')}
  </Item>
)
